import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { API, rupiah, fmtTgl, pesanGalat } from "../lib/api";
import Shell from "../components/Shell";
import { JudulHalaman, KerangkaBaris, KeadaanGalat, Angka, CaraHitung, KELAS_TABEL, KELAS_TH, KELAS_TD } from "../components/kit";

export default function Dampak() {
  const [data, setData] = useState(null);
  const [galat, setGalat] = useState(null);
  const nav = useNavigate();
  const muat = () => {
    setGalat(null);
    API.get("/dampak").then((r) => setData(r.data)).catch((e) => setGalat(pesanGalat(e)));
  };
  useEffect(muat, []);

  return (
    <Shell>
      <JudulHalaman testid="judul-dampak" judul="Dampak"
        sub="Semua angka dihitung langsung dari data yang ada. Klik angka untuk melihat sumbernya." />
      {galat && <KeadaanGalat testid="galat-dampak" pesan={galat} onCoba={muat} />}
      {!data && !galat && <KerangkaBaris testid="memuat-dampak" n={6} />}
      {data && (
        <div className="space-y-10">
          <div className="grid grid-cols-1 md:grid-cols-4 border divide-y md:divide-y-0 md:divide-x" data-testid="grid-metrik">
            {data.metrik.map((m) => (
              <div key={m.kunci} className="p-4" data-testid={`metrik-${m.kunci}`}>
                <p className="text-xs uppercase tracking-wide text-muted-foreground">{m.label}</p>
                <button data-testid={`nilai-${m.kunci}`} onClick={() => nav(m.tautan)}
                  className="mt-1 text-3xl font-bold font-data tabular transition-colors duration-150 hover:text-blue-600 dark:hover:text-blue-400 text-left">
                  <Angka nilai={m.nilai} n={m.n} satuan={m.satuan} />
                </button>
                <p className="text-xs text-muted-foreground font-data mt-1">n={m.n}</p>
                <CaraHitung testid={`cara-${m.kunci}`} teks={m.cara_hitung} />
              </div>
            ))}
          </div>

          <section data-testid="seksi-rupiah">
            <h2 className="font-heading text-xl font-semibold">Biaya lisensi untuk pegawai yang sudah keluar</h2>
            <p className="text-sm text-muted-foreground mt-1 max-w-2xl">{data.rupiah.alasan}</p>
            {data.rupiah.nilai == null ? (
              <p className="mt-3 text-sm text-muted-foreground italic" data-testid="rupiah-kosong">belum ada data (n=0)</p>
            ) : (
              <>
                <p className="mt-3 font-data text-4xl font-bold tabular" data-testid="rupiah-total">{rupiah(data.rupiah.nilai)}</p>
                <div className="overflow-x-auto border mt-3">
                  <table className={KELAS_TABEL} data-testid="tabel-rincian-rupiah">
                    <thead>
                      <tr>
                        <th className={KELAS_TH}>Vendor</th><th className={KELAS_TH}>No. invoice</th><th className={KELAS_TH}>Kode orang</th>
                        <th className={KELAS_TH}>Harga/kursi tertulis</th><th className={KELAS_TH}>Bulan sejak keluar</th><th className={KELAS_TH}>Jumlah</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.rupiah.rincian.map((r, i) => (
                        <tr key={i}>
                          <td className={KELAS_TD}>{r.vendor}</td>
                          <td className={`${KELAS_TD} font-data`}>{r.nomor_invoice}</td>
                          <td className={`${KELAS_TD} font-data`}>{r.orang_kode}</td>
                          <td className={`${KELAS_TD} font-data`}>{rupiah(r.harga_per_kursi_tertulis)}</td>
                          <td className={`${KELAS_TD} font-data`}>{r.bulan_sejak_keluar}</td>
                          <td className={`${KELAS_TD} font-data`}>{rupiah(r.jumlah)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </>
            )}
          </section>

          <section data-testid="seksi-lain-lain">
            <h2 className="font-heading text-xl font-semibold">Permintaan non-akses</h2>
            <p className="mt-2 font-data text-2xl font-bold tabular" data-testid="angka-lain-lain">{data.lain_lain.teks}</p>
          </section>

          <section data-testid="seksi-dasar">
            <h2 className="font-heading text-xl font-semibold">Angka sebelum penggunaan PAM-IT</h2>
            {data.dasar.length === 0 ? (
              <p className="mt-3 text-sm text-muted-foreground italic">belum ada data (n=0)</p>
            ) : (
              <div className="overflow-x-auto border mt-3">
                <table className={KELAS_TABEL} data-testid="tabel-dasar">
                  <thead>
                    <tr>
                      <th className={KELAS_TH}>Metrik</th><th className={KELAS_TH}>Nilai sebelum</th><th className={KELAS_TH}>Satuan</th>
                      <th className={KELAS_TH}>Sumber</th><th className={KELAS_TH}>Tanggal ukur</th><th className={KELAS_TH}>Metode</th><th className={KELAS_TH}>n</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.dasar.map((d) => (
                      <tr key={d.id}>
                        <td className={KELAS_TD}>{d.metrik}</td>
                        <td className={`${KELAS_TD} font-data`}>{d.nilai_sebelum}</td>
                        <td className={KELAS_TD}>{d.satuan}</td>
                        <td className={`${KELAS_TD} text-xs`}>{d.sumber}</td>
                        <td className={`${KELAS_TD} font-data text-xs`}>{fmtTgl(d.tanggal_ukur)}</td>
                        <td className={`${KELAS_TD} text-xs`}>{d.metode}</td>
                        <td className={`${KELAS_TD} font-data`}>{d.n ?? "—"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </section>
          <p className="text-xs text-muted-foreground font-data" data-testid="dihitung-pada">Dihitung langsung pada: {data.dihitung_pada}</p>
        </div>
      )}
    </Shell>
  );
}
